import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IFile, ILocalFile } from 'interfaces-lib';
import { ContentTypeMapperService } from 'utils-service-lib';
import { INTRequest } from '../../../types/NTRequest';
import { INTCloseEventData } from '../notetaker-card.component';
import { ICall } from '../notetaker-result/ICallInterface';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss'],
  standalone: false,
})
export class UploadDialogComponent implements OnInit {
  audioFileTypes = ['mp3', 'wav', 'mp4'];
  fileName = '';
  // Todo list of questions remove from having in two files
  // ToDo move this to a useful place - similar to assist default global options

  NTRequest: INTRequest;
  duration: number | null = null; // original duration appears as seconds
  appointmentDate: string = new Date().toISOString().slice(0, 16);

  constructor(
    @Inject(MAT_DIALOG_DATA) public meta: Readonly<IDialogMeta>,
    private dialogRef: MatDialogRef<UploadDialogComponent>,
    private matDialog: MatDialog,
    private contentTypeMapperService: ContentTypeMapperService,
  ) {
    this.fileName = this.truncateExtension(meta.file.name);
    this.NTRequest = meta.NTRequest;
  }

  ngOnInit(): void {
    // TODO: Temporarily avoiding durations for calls from Bullhorn - needs reworking
    // TODO: Maybe not the best check? (type === null). Will also need to check if an audio file
    if (this.meta.file.type) { this.processFile((this.meta.file as ILocalFile).file); } // Process the file when the component initializes
    // else
    //   this.formattedDuration = this.formatDuration(480485);
  }

  processFile(file: File): void {
    const fileURL = URL.createObjectURL(file); // Create a URL for the file
    const audio = new Audio(fileURL); // Create an audio element for the file

    // When audio metadata is loaded, set duration and format it
    audio.onloadedmetadata = () => {
      this.duration = audio.duration; // Get the duration of the audio
      URL.revokeObjectURL(fileURL); // Clean up the object URL
    };

    // Handle error if the audio file fails to load
    audio.onerror = () => {
      console.error('Failed to load the file.'); // Log an error message
      URL.revokeObjectURL(fileURL); // Clean up the object URL
    };
  }

  protected closeDialog(e: any = null): void {
    this.dialogRef.close(false);
  }

  transcribe(): void {
    const call = this.getCallInfo();
    this.NTRequest.file = this.meta.file;
    // TODO get from client config
    this.NTRequest.questionPackId = this.meta.NTRequest.questionPackId;
    this.NTRequest.transcribe = this.isAudioFile(this.meta.file);
    this.dialogRef.close({
      call: call,
      action: 'upload',
      NTRequest: this.NTRequest,
    } as INTCloseEventData);
  }

  private getCallInfo(): ICall {
    return {
      corpId: '',
      callId: '',
      entityId: '',
      status: '',
      description: this.fileName,
      transcript: [],
      questions: [],
      summary: undefined,
      date: new Date(this.appointmentDate).toISOString(),
      duration: '',
      callerId: '',
      attendeeEmail: '',
    };
  }

  private truncateExtension(fileName: string): string {
    const lastPeriodIndex = fileName.lastIndexOf('.');

    if (lastPeriodIndex > 0) {
      return fileName.substring(0, lastPeriodIndex);
    }
    return fileName;
  }

  private isAudioFile(file: IFile): boolean {
    const fixedFile = this.contentTypeMapperService.normaliseFileExtension(file, true);
    return this.audioFileTypes.includes(fixedFile.fileExtension);
  }

  private formatDuration(seconds: number): string {
    const minutes = Math.floor(seconds / 60); // Calculate minutes
    const remainingSeconds = Math.floor(seconds % 60); // Calculate remaining seconds
    return `${minutes}m ${remainingSeconds}s`; // Return formatted duration
  }

  // Keyboard Shortcut - Use Esc to clear
  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {
    if (this.matDialog.openDialogs.length === 1) {
      if (event.code === 'Escape') {
        this.dialogRef.close();
      }
    }
  }
}

export interface IDialogMeta {
  file: IFile | ILocalFile;
  NTRequest: INTRequest;
}
